import React, { useState, useEffect, useRef, useContext } from 'react'
import { ApiGetCall, ApiGetCallAuthKey, ApiPostCallAuthKey } from '../JS/Connector';
import { HideLoder, LogInUserID, onKeyDownRestrict, onPasteRestriction, ShowLoder } from '../JS/Common';
import AlertsComp from '../Components/AlertsComp';
import { typewatch } from '../JS/Common';
import { faArrowRightToBracket } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AlertPopup from './AlertPopup';
import { UserContext } from '../App';
import { useDispatch } from 'react-redux';
import { setAdminSchoolId, setCsvUserID, setDefaultTicketStatus, setSchoolContactID, setSchoolId, setSchoolname, setSchoolnumber, setSelectedSchoolTimeZone } from '../Store/Slices/authSlice';
import { useSelector } from 'react-redux';
import { hasRoleAccess, RoleEnum } from '../JS/RoleType';
import useConfig from '../Hooks/useConfig';
import CustomFontAwesomeIcon from './CustomFontAwesomeIcon';

export function Schoolsearchbar(props) {
  const { organization, login_as_admin, adminCallNode } = useConfig();
  const StateData = useSelector((state) => state.authData);
  const { UserData } = useContext(UserContext);
  const [SearchForSchoolName, setSearchForSchoolName] = useState("");
  const [SuggestionBoxArray, setSuggestionBoxArray] = useState([]);
  const [innerload, setinnerload] = useState(false);
  const [SchoolSuggestiobBox, setSchoolSuggestiobBox] = useState({
    ShowSuggestion: "d-none",
  });
  const [SchoolData, setSchoolData] = useState({
    Schoolname: '',
    SchoolID: '',
    schoolTimeZone: '',
    defaultTicketStatus: ''
  });
  const [loading, setLoading] = useState(false);
  const [WarningPopup, setWarningPopup] = useState(false);
  const [PendingSchoolSelection, setPendingSchoolSelection] = useState(null);
  const [Alerts, setAlerts] = useState("");
  const SchoolContactid = StateData?.SchoolContactID;
  const storedSchoolname = StateData?.Schoolname;
  const suggestionBoxRef = useRef(null);
  const reduxDispatch = useDispatch();
  useEffect(() => {
    const storedSearchValue = StateData?.AdminSchoolId;
    setSchoolData({ ...SchoolData, Schoolname: storedSchoolname, SchoolID: storedSearchValue, schoolTimeZone: StateData?.SelectedSchoolTimeZone, defaultTicketStatus: StateData?.DefaultTicketStatus })
    const handleClickOutside = (event) => {
      if (suggestionBoxRef.current && !suggestionBoxRef.current.contains(event.target)) {
        setSchoolSuggestiobBox({ ...SchoolSuggestiobBox, ShowSuggestion: "d-none" })
      }
    };
    const handleWindowClick = (event) => {
      handleClickOutside(event);
    };
    window.addEventListener('click', handleWindowClick);
    return () => {
      window.removeEventListener('click', handleWindowClick);
    };
  }, [StateData])

  useEffect(() => {
    syncSchoolTimezone();
  }, []);

  async function syncSchoolTimezone() {
    if (StateData?.AdminSchoolId) {
      await ApiGetCall(`/schools/by-id?schoolId=${StateData.AdminSchoolId}`).then((result) => {
        if (result == undefined || result == "") {
          alert("Something went wrong");
        } else {
          const responseRs = JSON.parse(result);
          if (responseRs?.timezone_data?.timezone) {
            reduxDispatch(setSelectedSchoolTimeZone(responseRs?.timezone_data?.timezone));
          }
        }
      });
    }
  }

  async function showSchoolName(searchString) {
    if (searchString?.trim() == "") {
      searchString = null;
    } else {
      searchString = searchString?.trim();
    }
    setSchoolSuggestiobBox({ ...SchoolSuggestiobBox, ShowSuggestion: "" });
    setSuggestionBoxArray([])
    typewatch(async function () {
      setinnerload(true);
      await ApiGetCall(`/schools/list?search=${searchString}&userId=${LogInUserID}`).then((result) => {
        if (result == undefined || result == "") {
          alert("Something went wrong");
        } else {
          const responseRs = JSON.parse(result);
          var sugData = responseRs.msg;
          var sugArray = [];
          var i = 1;

          if (sugData.length !== 0) {
            const sugArray = sugData.map((school, i) => {
              const isSameLocation = school.location_assign_flag == 1;
              const effectiveRole = UserData.copyrole || UserData.role || null;
              const shouldRestrict = hasRoleAccess(effectiveRole, RoleEnum.ONLY_TECH);

              const handleClick = (schoolData) => {
                if (props?.resetGridEffectSkip) {
                  props?.resetGridEffectSkip();
                }
                if (shouldRestrict && !isSameLocation) {
                  setPendingSchoolSelection(school);
                  setWarningPopup(true);
                  if (props.setSelectAllFlag) {
                    props.setSelectAllFlag(0);
                  }
                } else {
                  if (props.setCurrentPage) {
                    props.setCurrentPage(1);
                  }
                  setSearchForSchoolName("");
                  showSchoolData(schoolData);
                }
              };

              return (
                <div
                  className={`row brdr-Btm font-14 `}
                  key={i}
                  id={school.id}
                  name={school.name}
                  olduserid={school.oldest_user_id}
                  schoolTimeZone={school?.timezone_data?.timezone}
                  defaultTicketStatus={school.default_ticket_status == 1 ? 1 : 0}
                  onClick={() => handleClick(school)}
                >
                  <div className={`col-12 text-start ${isSameLocation ? 'blueText' : ''}`} style={{ padding: "8px 15px" }}>
                    {school.name}
                  </div>
                </div>
              );
            });

            setSuggestionBoxArray(sugArray);
          } else {
            setSuggestionBoxArray([
              <div className="col-12 text-center" key="no-record">
                <label>No Record Found</label>
              </div>
            ]);
          }
          setinnerload(false);
        }
      });
    }, 500);
  }

  function showSchoolData(eOrObj) {
    if (props.setSelectAllFlag) {
      props.setSelectAllFlag(0);
    }
    if (props.setSelectBuildingID) {
      props.setSelectBuildingID("");
    }
    if (props.setselectedbatchid) {
      props.setselectedbatchid(0)
    }
    let id, name, contactid, schoolTimeZone, defaultTicketStatus;

    setSchoolSuggestiobBox({ ...SchoolSuggestiobBox, ShowSuggestion: 'd-none' });

    id = eOrObj?.id
    name = eOrObj?.name
    contactid = eOrObj?.oldest_user_id || null
    schoolTimeZone = eOrObj?.timezone_data?.timezone || null
    defaultTicketStatus = eOrObj?.default_ticket_status == 1 ? 1 : 0

    var expires = 1;
    reduxDispatch(setAdminSchoolId(id));
    reduxDispatch(setSchoolContactID(contactid));
    reduxDispatch(setSchoolname(name));
    reduxDispatch(setSelectedSchoolTimeZone(schoolTimeZone));
    reduxDispatch(setDefaultTicketStatus(defaultTicketStatus));
    props.schlid(id);
    if (props.flag == 1) {
      props.GetGridData(id, 1, null, 2, false);
    } else if (props.flag == 2) {
      props.GetGridData(id, 1, null, 3, false);
    } else if (props.tabflag == 1) {
      props.settabflag(1)
      props.GetGridData(null, 1, props.batchid, null, false)
    } else if (props.tabflag == 2) {
      props.settabflag(2)
      props.GetGridData(null, 2, props.batchid, null, false)
    } else if (props.tabflag == 3) {
      props.settabflag(3)
      props.GetGridData(null, 3, props.batchid, null, false)
    } else if (props.tabflag == 4) {
      props.settabflag(4)
      props.GetGridData(null, 4, props.batchid, null, false)
    } else if (props.flag == 5) {
      props.GetGridData(id, null, null, 1, false)
    }
    setSchoolData({ ...SchoolData, Schoolname: name, SchoolID: id, schoolTimeZone: schoolTimeZone, defaultTicketStatus: defaultTicketStatus })
    // Clear all state for Incoming Batches
    if (props.setSelectedIdsAll) {
      props.setSelectedIdsAll([]);
    }
    if (props.setSelectedIdsOpen) {
      props.setSelectedIdsOpen([])
    }
    if (props.setSelectedIdsSentOut) {
      props.setSelectedIdsSentOut([])
    }
    if (props.setSelectedIdsAtVendor) {
      props.setSelectedIdsAtVendor([])
    }
    if (props.setSelectedIdsRepairFinished) {
      props.setSelectedIdsRepairFinished([])
    }
    if (props.setSelectedIdsRepairBilled) {
      props.setSelectedIdsRepairBilled([])
    }
    if (props.setSelectedIdsOpen1) {
      props.setSelectedIdsOpen1([])
    }
    if (props.setSelectedIdsSentOut1) {
      props.setSelectedIdsSentOut1([])
    }
    if (props.setSelectedIdsAtVendor1) {
      props.setSelectedIdsAtVendor1([])
    }
    if (props.setSelectedIdsRepairFinished1) {
      props.setSelectedIdsRepairFinished1([])
    }
    if (props.setSelectedIdsRepairBilled1) {
      props.setSelectedIdsRepairBilled1([])
    }
  }

  async function LoginIntoSchool() {
    setLoading(true);
    var raw = JSON.stringify({
      loginUserId: LogInUserID,
      schoolAdminId: SchoolContactid,
      flag: 1,
    });
    await ApiPostCallAuthKey(`${adminCallNode}/technicians/set-school-login`, raw).then((result) => {
      setLoading(false);
      if (result == undefined || result == "") {
        alert("Something went wrong");
      } else {
        const responseRs = JSON.parse(result);
        var sugData = responseRs.k12data;
        if (responseRs.status == "success") {
          reduxDispatch(setCsvUserID(sugData.id));
          reduxDispatch(setSchoolId(responseRs.schooldata.school_id));
          if (responseRs.schooldata.school != null) {
            reduxDispatch(setSchoolnumber(responseRs.schooldata.school.school_number));
          } else {
            reduxDispatch(setSchoolnumber(''));
          }
          window.location.href = '/manage-tickets';
        } else {
          setAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.status} />);
          setTimeout(() => {
            setAlerts(<AlertsComp show={false} />)
          }, 2000);
        }

      }
    });
  }
  const timeZoneAccess = hasRoleAccess(UserData.copyrole || UserData.role || null, RoleEnum.ALL_ADMINS)
  return (
    <>
      {Alerts}
      {loading ? <ShowLoder /> : <HideLoder />}
      <div className="row align-items-center px-3">
        <div className="col-md-4 px-0">
          <form className="gridsearchbar" onSubmit={(e) => e.preventDefault()}>
            <div className="position-absolute top-50 translate-middle-y search-icon ms-3 searchIcon"><i className="bi bi-search searchIconClass"></i></div>
            <input className="form-control" autoComplete="off" type="text" placeholder={`Search ${organization}`} style={{ backgroundColor: '#f9fafb' }}
              value={SearchForSchoolName} onChange={(e) => { setSearchForSchoolName(e.target.value) }}
              onKeyUp={(e) => showSchoolName(e.target.value)}
              onPaste={onPasteRestriction}
              onKeyDown={onKeyDownRestrict}
            />
            <div className={`SuggestionBoxDiv ${SchoolSuggestiobBox.ShowSuggestion}`} style={{ zIndex: '1' }} ref={suggestionBoxRef}>
              {innerload && (
                <div className='row'>
                  <div className="col-12 text-center pt-2">
                    <img src="images/loder.svg" className="" style={{ width: "30px" }} />
                  </div>
                </div>
              )}

              {SuggestionBoxArray}
            </div>
          </form>
        </div>
        <div className='col-md-8 d-flex SearchBarDiv schoolNameClass pe-0 align-items-center'><h6 className="fw-500 mb-0">{SchoolData.Schoolname}</h6>
          {SchoolData.Schoolname ?
            props.SchoolLoginFlag == 1 && (
              <>
                <CustomFontAwesomeIcon icon={faArrowRightToBracket} title={login_as_admin} className='parent-icon cursor-pointer ps-2' onClick={() => LoginIntoSchool()} />
              </>
            )
            : <></>
          }
          {StateData?.SelectedSchoolTimeZone && timeZoneAccess && (
            <span>
              <div className="dropdown-item ms-5">
                <span>{organization} Timezone : {StateData?.SelectedSchoolTimeZone || "America/New_York"}</span>
              </div>
            </span>
          )}
        </div>
      </div >

      <AlertPopup isshow={WarningPopup} img={'/images/greenInfo.svg'}
        headingtext={''} text={`You have just selected a ${organization} that does not belong to the location you are assigned to. Double check the ${organization} name and verify you selected the right account. Proceed?`}
        cancelcall={(e) => setWarningPopup(false)}
        canceltext={"No"} successtext={"Yes"} successcall={() => {
          setWarningPopup(false);
          if (PendingSchoolSelection) {
            if (props.setCurrentPage) {
              props.setCurrentPage(1);
            }
            setSearchForSchoolName("");
            showSchoolData(PendingSchoolSelection);
            setPendingSchoolSelection(null);
          }
        }} btntype={'SaveBtn'} />
    </>
  )
}
